var path = '/templates/zenclerk_s/sites/invoices/navigation.html';
var html = "<a ng-class=\"{active:vm.isCategory('invoices')}\" ui-sref=\"zenclerkS.project.invoices.list({ apikey: vm.project.apikey })\">{{ 'sites.invoices.navigation.seikyuu' | translate }}</a> <a master-only ng-class=\"{active:vm.isCategory('invoicesEdit')}\" ui-sref=\"zenclerkS.project.invoices.edit({ apikey: vm.project.apikey, term: vm.$stateParams.term })\" ng-if=vm.$stateParams.term>{{ 'sites.invoices.navigation.henshuu' | translate }} <i class=\"fa fa-lock master-only\"></i></a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/invoices/navigation.html
// module id = 1421
// module chunks = 0